import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Modal, ModalBody, Form, FormGroup, Button } from 'reactstrap';
import { TemplateItem } from '@shoflo/polymer';
import { faUpload } from '@fortawesome/free-solid-svg-icons';
import { selectLastMediaSource } from '@shoflo/studio-redux/selectors';
import { takeBackgroundLive } from 'actions/templates';
import { BACKGROUND_PICKER, BACKGROUND_FORM } from 'constants/Modal';
import { useModal } from 'hooks';
import { showModal } from '@shoflo/studio-redux/actions';
import {
  StyledCloseButton,
  StyledModalHeader,
  StyledJustifyRight,
  StyledWrapper,
  StyledUploadButton,
  StyledFontAwesomeIcon,
} from './BackgroundPicker.styled';

function BackgroundPicker() {
  const dispatch = useDispatch();

  const [templateName, setTemplateName] = useState('');
  const { isOpen, clear } = useModal(BACKGROUND_PICKER);
  const isAddButtonDisabled = !templateName;
  const { order: lastMediaOrder = 0 } = useSelector(selectLastMediaSource);
  const { templates: templateMedia, isLoading } = useSelector(
    ({ templates }) => templates
  );

  function handleChange(e) {
    const { value } = e.target;
    setTemplateName(value);
  }

  function uploadBackground() {
    dispatch(showModal(BACKGROUND_FORM));
  }

  function handleAdd(e) {
    e.preventDefault();
    const selectedTemplate = templateMedia.find(
      (template) => template.key === templateName
    );

    onSelectTemplate({
      ...selectedTemplate,
      isEventTemplate: false,
      media: null,
    });
  }

  function onSelectTemplate(template) {
    const payload = {
      _id: template._id,
      title: template.name || template.key,
      order: lastMediaOrder + 1,
      value: { eventDocId: template._id, url: template.url },
    };

    dispatch(
      takeBackgroundLive({
        ...payload,
        type: 'backgrounds',
        value: template.value,
        isEventTemplate: template.isEventTemplate,
      })
    );

    clear();
  }

  const wrapperId = 'media-template-chooser-container';
  const containerElementSelector = `#${wrapperId}`;

  return (
    <Modal
      size="xl"
      isOpen={isOpen}
      toggle={clear}
      data-testid="media-template-chooser-modal"
    >
      <StyledModalHeader>
        <div className="top">
          <h5>Choose a background image</h5>
          <StyledUploadButton
            size="sm"
            color="default"
            onClick={uploadBackground}
            data-testid="uploadImageButton"
            data-dd-action-name="Upload background"
          >
            <StyledFontAwesomeIcon
              data-testid="uploadIcon"
              icon={faUpload}
              size="xs"
            />
            Upload image
          </StyledUploadButton>
        </div>
        <p>Select a background image, or you can upload your own.</p>
      </StyledModalHeader>
      <ModalBody>
        <StyledWrapper id={wrapperId}>
          {!isLoading
            ? templateMedia.map((item, index) => (
                <TemplateItem
                  item={item}
                  index={index}
                  key={index}
                  title={item.title}
                  handleChange={handleChange}
                  containerElementSelector={containerElementSelector}
                />
              ))
            : null}
        </StyledWrapper>

        <Form data-testid="templateChooserForm" onSubmit={handleAdd}>
          <FormGroup>
            <div className="float-end" style={{ display: 'flex' }}>
              <Button
                data-testid="chooseTemplate"
                color="primary"
                disabled={isAddButtonDisabled}
                data-dd-action-name="Save Background"
              >
                Save
              </Button>

              <StyledJustifyRight>
                <StyledCloseButton
                  data-testid="closeButton"
                  data-dd-action-name="Close upload background modal"
                  color="default"
                  onClick={(e) => {
                    e.preventDefault();
                    clear();
                  }}
                >
                  Close
                </StyledCloseButton>
              </StyledJustifyRight>
            </div>
          </FormGroup>
        </Form>
      </ModalBody>
    </Modal>
  );
}

export default BackgroundPicker;
